import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_2t1ui5ps: FaireBrandEntity = {
  token: "b_2t1ui5ps",
  type: "brand",
  name: "Paper Anchor Co.",
  avatarUrl:
    "https://cdn.faire.com/fastly/f92a5c31748cd9bf3adf37e615f291bee727ee206b97cb49a50b065c170ebee0.png",
  bannerUrl:
    "https://cdn.faire.com/fastly/5a2fb2925e446c1424d6d26bcee57ae428883560deadc26f5290cf60cdeedc24.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/f92a5c31748cd9bf3adf37e615f291bee727ee206b97cb49a50b065c170ebee0.png",
  heroImageUrl:
    "https://cdn.faire.com/fastly/5a2fb2925e446c1424d6d26bcee57ae428883560deadc26f5290cf60cdeedc24.jpeg",
  location: "San Diego, CA, USA",
  minimumOrderDollars: 150,
  rating: 5,
  reviewCount: 378,
  isTopShop: true,
  isInsider: true,
  description:
    "Paper Anchor Co. is a nature-inspired stationery and gift brand, blending hand-painted artistry with the beauty and awe of nature to enhance our everyday moments.\n\nEvery product we design starts by hand—from rough sketch, to hand painting or illustration, to finished product. We aspire for every greeting card, coaster, keychain and more to become its own piece of art to admire, cherish and share with others.\n\nWe are passionate about creating with intention—our products are made using high quality materials as well as natural, recycled and recyclable materials. We are also committed to offering plastic-free packaging that is compostable or recyclable.\n\nOur products can be found in 29 Botanical Garden & Conservatory Gift Shops across the United States as well as over 2,000 garden, gift and flower shops worldwide.\n\nThank you so much for stopping by. We look forward to the opportunity of flourishing a wonderful partnership.",
  meta: {
    source: "api",
    importedAt: "2026-07-31T16:23:47.536Z",
    importedBy: "entity-db-cli",
  },
};
